'use client';

import { c as _c } from "react/compiler-runtime";
import { trackPartnerProfileEntryClick } from '@feat/feat-tracking/partner-profile';
import { useFeatureValue } from '@growthbook/growthbook-react';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { MerchantProfileLoading } from 'src/app/_page-chrome/merchant-profile-loading';
import { hasActivePartnerProfile } from 'src/app/erlebnisse/_lib/partnerbox';
import { buildPartnerUrl } from 'src/app/partner/_lib/partner-url';
import type { Merchant } from 'src/features/merchant/merchant-profile';
import { AppExperiencePartnerProfileModal } from './app-experience-partner-profile-modal';
const MerchantProfile = dynamic(() => import('src/features/merchant/merchant-profile').then(mod => mod.MerchantProfile), {
  loading: () => <MerchantProfileLoading />
});
type PartnerboxMerchant = Merchant & {
  publicId?: number | null;
  slug?: string | null;
  profileActive?: boolean | null;
};
type AppExperienceMerchantProfileProps = {
  merchant?: PartnerboxMerchant | null;
  onShowImprint?: () => void;
};

// The `ab-partnerbox-profile-entry` flag is read only once a profile exists, so
// the experiment's exposure events count profile-having impressions rather than
// every EDP view.
export function AppExperienceMerchantProfile(t0) {
  const $ = _c(6);
  const {
    merchant,
    onShowImprint
  } = t0;
  if (!hasActivePartnerProfile(merchant)) {
    let t1;
    if ($[0] !== merchant || $[1] !== onShowImprint) {
      t1 = <MerchantProfile merchant={merchant} onShowImprint={onShowImprint} />;
      $[0] = merchant;
      $[1] = onShowImprint;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== merchant || $[4] !== onShowImprint) {
    t1 = <PartnerboxWithProfile merchant={merchant} publicId={merchant.publicId} slug={merchant.slug} onShowImprint={onShowImprint} />;
    $[3] = merchant;
    $[4] = onShowImprint;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function PartnerboxWithProfile(t0) {
  const $ = _c(21);
  const {
    merchant,
    publicId,
    slug,
    onShowImprint
  } = t0;
  const variant = useFeatureValue("ab-partnerbox-profile-entry", "direct-link");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const ariaLabel = `Profil von ${merchant.tradeName ?? ""} ansehen`;
  let t1;
  if ($[0] !== publicId || $[1] !== variant) {
    t1 = () => trackPartnerProfileEntryClick(variant, publicId);
    $[0] = publicId;
    $[1] = variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleEntryClick = t1;
  let t2;
  if ($[3] !== ariaLabel || $[4] !== handleEntryClick || $[5] !== publicId || $[6] !== slug || $[7] !== variant) {
    t2 = variant === "modal" ? <button type="button" aria-label={ariaLabel} className="absolute inset-0 z-0 cursor-pointer appearance-none border-0 bg-transparent p-0" onClick={() => setIsModalOpen(true)} /> : <a href={buildPartnerUrl({
      publicId,
      slug
    })} target="_blank" rel="noopener" className="absolute inset-0 z-0" onClick={handleEntryClick}><span className="sr-only">{ariaLabel}</span></a>;
    $[3] = ariaLabel;
    $[4] = handleEntryClick;
    $[5] = publicId;
    $[6] = slug;
    $[7] = variant;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== merchant || $[10] !== onShowImprint) {
    t3 = <MerchantProfile merchant={merchant} onShowImprint={onShowImprint} />;
    $[9] = merchant;
    $[10] = onShowImprint;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== handleEntryClick || $[13] !== isModalOpen || $[14] !== publicId || $[15] !== variant) {
    t4 = variant === "modal" && <AppExperiencePartnerProfileModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} publicId={publicId} onViewProfileClick={handleEntryClick} />;
    $[12] = handleEntryClick;
    $[13] = isModalOpen;
    $[14] = publicId;
    $[15] = variant;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t5 = <div className="relative">{t2}{t3}{t4}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}